/* eslint-ignore */
// @ts-nocheck
import React, { useCallback, useState, useEffect, useMemo } from 'react';

import { useMediaQuery } from 'react-responsive';

import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';
import { RiLockPasswordLine } from 'react-icons/ri';
import { calcularForcaDeSenha } from 'utils/functions';
import { postUserPassword, postUserToken } from 'services/firstAccessServices';
import { useFirstAccess } from '../../../../../hooks/useFirstAccess';

import CustomToolip from './CustomToolip';
import PasswordForceMobile from './PasswordForceMobile';

import {
  Container,
  Title,
  Text,
  FormContainer,
  InputCond,
  InputDoc,
  WrapSearchDocument,
  SearchDocumentText,
  SearchDocumentIcon,
  ButtonNext,
  ButtonBack,
  ButtonText,
  ButtonsWrap,
} from './styles';

function PasswordRegistration({ activeStep, setActiveStep }) {
  const isMobile = useMediaQuery({ maxWidth: 959 });

  const [passwordError, setPasswordError] = useState('');
  const [passwordAgainError, setPasswordAgainError] = useState('');
  const [showMobileMode, setShowMobileMode] = useState(true);
  const [showPasswordForce, setShowPasswordForce] = useState(false);

  const {
    password,
    handleSetPassword,
    passwordAgain,
    handleSetPasswordAgain,
    contactId,
    userId,
    codCond,
    email,
    document,
  } = useFirstAccess();

  useEffect(() => {
    setShowMobileMode(isMobile);
  }, [isMobile]);

  const handleShowPasswordForce = useCallback(() => {
    setShowPasswordForce(!showPasswordForce);
  }, [showPasswordForce]);

  const handlePassword = useCallback(
    (e) => {
      setPasswordError('');
      setPasswordAgainError('');
      const passwordValue = e.target.value;
      const {
        maiusculasOK,
        minusculasOK,
        numerosOK,
        especiaisOK,
        tamanhoMinOK,
      } = calcularForcaDeSenha(passwordValue);

      if (!tamanhoMinOK) {
        setPasswordError('A senha deve ter, no mínimo, 8 caracteres');
      }
      if (!maiusculasOK) {
        setPasswordError('A senha deve ter pelo menos 1 letra maiúscula');
      }
      if (!minusculasOK) {
        setPasswordError('A senha deve ter pelo menos 1 letra minúscula');
      }
      if (!numerosOK) {
        setPasswordError('A senha deve ter pelo menos 1 número');
      }
      if (!especiaisOK) {
        setPasswordError('A senha deve ter pelo menos 1 caracter especial');
      }
      if (passwordAgain !== passwordValue) {
        setPasswordAgainError('As senhas não se coincidem');
      }

      handleSetPassword(passwordValue);
    },
    [password, passwordAgain]
  );

  const handlePasswordAgain = useCallback(
    async (e) => {
      setPasswordAgainError('');
      const passwordAgainValue = e.target.value;
      if (passwordAgainValue !== password)
        setPasswordAgainError('As senhas não se coincidem');
      handleSetPasswordAgain(passwordAgainValue);
    },
    [password]
  );

  const handleNextStepClick = useCallback(async () => {
    if (!password) {
      setPasswordError('Campo obrigatório');
    }
    if (!passwordAgain) {
      setPasswordAgainError('Campo obrigatório');
    }

    if (password && passwordAgain && !passwordError && !passwordAgainError) {
      const createPasswordSuccess = await postUserPassword(
        contactId,
        password,
        passwordAgain,
        userId
      );
      if (createPasswordSuccess) {
        const successUserToken = await postUserToken(
          contactId,
          codCond,
          document,
          userId,
          email
        );
        if (successUserToken) {
          setActiveStep(activeStep + 1);
        }
      }
    }
  }, [contactId, document, userId, email, password, passwordAgain, codCond]);

  const showBack = useMemo(() => {
    return false;
  }, []);

  return (
    <Container>
      <Title>Cadastro de senha</Title>
      <Text>Agora vamos cadastrar sua senha de acesso!</Text>
      <FormContainer>
        <InputCond
          labelText="Senha"
          inputType="password"
          inputName="password"
          inputId="password"
          value={password}
          onChange={handlePassword}
          icon={RiLockPasswordLine}
          msgError={passwordError}
        />
        <WrapSearchDocument>
          {!showMobileMode && (
            <CustomToolip title="Requisitos de Senha">
              <SearchDocumentText>Requisitos de senha</SearchDocumentText>
              <SearchDocumentIcon>!</SearchDocumentIcon>
            </CustomToolip>
          )}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
            }}
          >
            {showMobileMode && (
              <div
                style={{
                  display: 'flex',
                }}
                onClick={handleShowPasswordForce}
              >
                <SearchDocumentText>Requisitos de senha</SearchDocumentText>
                <SearchDocumentIcon>!</SearchDocumentIcon>
              </div>
            )}

            {showMobileMode && showPasswordForce && <PasswordForceMobile />}
          </div>
        </WrapSearchDocument>
        <InputDoc
          className="passwordAgain"
          labelText="Confirmação de senha"
          inputType="password"
          inputName="passwordAgain"
          inputId="passwordAgain"
          value={passwordAgain}
          onChange={handlePasswordAgain}
          icon={RiLockPasswordLine}
          msgError={passwordAgainError}
        />
        <ButtonsWrap>
          <ButtonNext
            buttonType="primary"
            iconRight={AiOutlineArrowRight}
            onClick={handleNextStepClick}
          >
            Continuar
          </ButtonNext>
          {showBack && (
            <ButtonBack
              buttonType="outline"
              iconLeft={AiOutlineArrowLeft}
              onClick={() => setActiveStep(activeStep - 1)}
            >
              <ButtonText>Voltar</ButtonText>
            </ButtonBack>
          )}
        </ButtonsWrap>
      </FormContainer>
    </Container>
  );
}

export default PasswordRegistration;
